import { Injectable } from '@angular/core';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private storage = getStorage();

  constructor() {}

  /**
   * Carica un file su Firebase Storage e ottieni l'URL pubblico.
   * @param type Tipo di file (photos, audios, videos, pdf)
   * @param file File selezionato
   * @returns Promise<string> URL pubblico dell'immagine caricata
   */
  async uploadImageAndGetUrl(type: 'photos' | 'audios' | 'videos' | 'albums' | 'pdf',file: File): Promise<string> {
    if (!file) {
      throw new Error('Nessun file selezionato');
    }

    const storageRef = ref(this.storage, `${type}/${file.name}`); // Crea un riferimento nel bucket
    await uploadBytes(storageRef, file); // Carica l'immagine su Firebase Storage
    const url = await getDownloadURL(storageRef); // Ottieni l'URL pubblico dell'immagine

    //console.log('File caricato con successo:', url);
    return url; // Restituisci l'URL pubblico
  }

}
